
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $729ae839c55d8d77$exports = {};

$parcel$export($729ae839c55d8d77$exports, "spectrum--light", () => $729ae839c55d8d77$export$efb37c2f79da8163, (v) => $729ae839c55d8d77$export$efb37c2f79da8163 = v);
var $729ae839c55d8d77$export$efb37c2f79da8163;
$729ae839c55d8d77$export$efb37c2f79da8163 = `YqfL3a_spectrum--light`;


export {$729ae839c55d8d77$exports as default};
//# sourceMappingURL=vars_spectrum-light_css.module.js.map
